export interface ShareState {
  partnerId: string;
  amountCents: number | null;
}

/// Divide o valor entre os sócios já escolhidos, sem perder nem inventar centavo: todos iguais e o
/// último absorve a diferença. R$ 100,00 entre 3 vira 33,33 + 33,33 + 33,34.
///
/// O caso comum é meio a meio, e digitar os dois valores à mão para chegar nisso é trabalho que a
/// tela pode fazer. O resultado continua editável: divisão desigual também acontece.
export function splitEvenly(form: {
  amountCents: number | null;
  shares: ShareState[];
}): ShareState[] {
  const chosen = form.shares.filter((share) => share.partnerId !== '');
  if (form.amountCents === null || chosen.length === 0) return form.shares;

  const base = Math.floor(form.amountCents / chosen.length);
  const remainder = form.amountCents - base * chosen.length;
  let position = 0;
  return form.shares.map((share) => {
    // Linha sem sócio escolhido fica como está: não há a quem atribuir o valor.
    if (share.partnerId === '') return share;
    position += 1;
    return { ...share, amountCents: position === chosen.length ? base + remainder : base };
  });
}
